var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AskOkMessage } from "flavr-common";
import { RequestCameraTakeSnapshotMessage, ResponseCameraTakeSnapshotMessage } from "@messages/media/CameraTakeSnapshotMessages";
import { DownloadMediaFileMessage } from "@messages/media/MediaFileMessages";
import { busService } from "@modules/bus";
const busConnection = busService.connection("ScriptCameraService");
export class ScriptCamera {
    static takeSnapshot(cameraUid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield busConnection.askByMessageType(new RequestCameraTakeSnapshotMessage(cameraUid), ResponseCameraTakeSnapshotMessage);
                return {
                    fileId: response.fileId,
                    url: response.imageUrl
                };
            }
            catch (error) {
                console.error(error);
                return undefined;
            }
        });
    }
    static downloadSnapshot(fileId, fileName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield busConnection.askByMessageType(new DownloadMediaFileMessage(fileId, fileName), AskOkMessage);
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        });
    }
}
